import { fork, call, put, all, takeEvery } from 'redux-saga/effects';
import asyncInterface from '../../../../asyncInterface';
import axios from 'axios';
import * as actionTypes from './actionTypes';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.contributionsDashboard.fetchAccountData(fetchPayload);
}

export function postAccountData(fetchPayload) {
  const postData = asyncInterface.init();
  return postData.contributionsDashboard.postContributionsData(fetchPayload);
}

export function* pendingContributionsDataFetch(data) {
  yield put({
    type: actionTypes.pendingContributionLoaderType,
  });
  try {
    const response = yield call(postAccountData, data);
    yield put({
      type: actionTypes.pendingContributionSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.pendingContributionsFailedType,
      error,
    });
  }
}

export function* completedContributionsDataFetch(data) {
  yield put({
    type: actionTypes.completedContributionsLoaderType,
  });
  try {
    const response = yield call(postAccountData, data);
    yield put({
      type: actionTypes.completedContributionsSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.completedContributionsFailedType,
      error,
    });
  }
}

export function* taxReceiptDataFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.taxDataSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.taxDataFailedType,
      error,
    });
  }
}

export function* lazyDataFetch(data) {
  yield put({
    type: actionTypes.lazyLoadDataLoaderType,
  });
  if (data.data.type === 'PENDING') {
    try {
      const response = yield call(postAccountData, data);
      yield put({
        type: actionTypes.lazyLoadPendingDataSuccessType,
        payload: response.data,
      });
    } catch (error) {
      yield put({
        type: actionTypes.lazyLoadDataFailedType,
        error,
      });
    }
  } else if (data.data.type === 'COMPLETED') {
    try {
      const response = yield call(postAccountData, data);
      yield put({
        type: actionTypes.lazyLoadCompletedDataSuccessType,
        payload: response.data,
      });
    } catch (error) {
      yield put({
        type: actionTypes.lazyLoadDataFailedType,
        error,
      });
    }
  }
}

export function* saveContributionsData(res) {
  yield put({
    type: actionTypes.contributionsDashboardDataSuccessType,
    payload: res.data,
  });
}

export function* fetchAllContributions(data) {
  yield put({ type: actionTypes.allContributionsDashboardDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.allContributionsDashboardDataSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: actionTypes.allContributionsDashboardDataFailedType,
      payload: err,
    });
  }
}

export function* contributionDashboardDataFetch(data, allData) {
  yield put({ type: actionTypes.contributionsDashboardDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield all([fork(saveContributionsData, response)]);
    if (response.data && response.data[0].y3 === true) {
      yield all([fork(fetchAllContributions, allData)]);
    }
  } catch (error) {
    yield put({
      type: actionTypes.contributionsDashboardDataFailedType,
      payload: error,
    });
  }
}

export function* valueYourContributionsDataFetch(data) {
  yield put({ type: actionTypes.valueYourContributionsLoadingType });
  try {
    const response = yield axios({
      method: 'GET',
      url: data.url,
      page: 'contributionDashboard',
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });
    yield put({
      type: actionTypes.valueYourContributionsSuccessType,
      payload: response.data[0].field_value_your_contribution,
    });
  } catch (err) {
    yield put({
      type: actionTypes.valueYourContributionsFailedType,
      payload: err,
    });
  }
}

export function* accountDataFecth(data) {
  yield put({ type: actionTypes.accountDataFetchLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.accountDataSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({ type: actionTypes.accountDataFailureType, payload: err });
  }
}

export function* ytdDataFetch(data) {
  yield put({ type: actionTypes.ytdDataFetchLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.ytdDataFetchSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({ type: actionTypes.ytdDataFetchFailedType, payload: err });
  }
}

export function* resetData() {
  yield put({ type: actionTypes.resetDataType });
}

export function* fetchContributionsDataWorker(fetchPayload) {
  yield all([
    fork(resetData),
    fork(accountDataFecth, fetchPayload.payload.metaData[0]),
    fork(ytdDataFetch, fetchPayload.payload.metaData[1]),
    fork(pendingContributionsDataFetch, fetchPayload.payload.metaData[2]),
    fork(completedContributionsDataFetch, fetchPayload.payload.metaData[3]),
    fork(taxReceiptDataFetch, fetchPayload.payload.metaData[4]),
    fork(
      contributionDashboardDataFetch,
      fetchPayload.payload.metaData[5],
      fetchPayload.payload.metaData[6]
    ),
    fork(valueYourContributionsDataFetch, fetchPayload.payload.metaData[7]),
  ]);
}

export function* fetchLazyDataWorker(fetchPayload) {
  yield all([fork(lazyDataFetch, fetchPayload.payload.metaData[0])]);
}

export function* fetchContributionDashboardDataWatcher() {
  yield takeEvery(
    actionTypes.dashboardDataFetchType,
    fetchContributionsDataWorker
  );
}

export function* fetchLazyDataWatcher() {
  yield takeEvery(actionTypes.fetchLazyDataType, fetchLazyDataWorker);
}

export function* putChartData(payload) {
  yield put({ type: actionTypes.storeChartDataLoadingType });
  try {
    yield put({
      type: actionTypes.storeChartDataSuccessType,
      payload: payload.payload,
    });
  } catch (err) {
    yield put({ type: actionTypes.storeChartDataFailedType, payload: err });
  }
}

export function* putChartDataWorker(dataPayload) {
  yield all([fork(putChartData, dataPayload)]);
}

export function* putChartDataWatcher() {
  yield takeEvery(actionTypes.storeChartDataType, putChartDataWorker);
}

export default function* contributionSagaWatcher() {
  yield all([fork(fetchContributionDashboardDataWatcher)]);
  yield all([fork(fetchLazyDataWatcher)]);
  yield all([fork(putChartDataWatcher)]);
}
